import React, { memo } from 'react';
import { LangInfo } from '../lang-info/LangInfo';
import { LangChooserToggleStyled } from './styled/LangChooserButtonStyled';
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import BinIcon from "../../../../components/icon/Icon";


export interface LangChooserButtonProps {
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    isHideArrowIcon?: boolean;
}

export const LangChooserButton = memo(({ isHideArrowIcon, onClick }: LangChooserButtonProps) => {
    const { lang } = useLangContext();
    return (
        <LangChooserToggleStyled onClick={onClick}>
            <LangInfo langName={lang?.lang_name || 'en'}/>
            {!isHideArrowIcon && (
                <>
                    {' '}<BinIcon name={'IcChevronDown'} className={'arrow-icon'} style={{ fill: 'currentcolor' }}/>
                </>
            )}
        </LangChooserToggleStyled>
    );
})